import { render, staticRenderFns } from "./PageRemerciement.vue?vue&type=template&id=3fb4b92c&scoped=true"
import script from "./PageRemerciement.vue?vue&type=script&lang=js"
export * from "./PageRemerciement.vue?vue&type=script&lang=js"
import style0 from "./PageRemerciement.vue?vue&type=style&index=0&id=3fb4b92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4b92c",
  null
  
)

export default component.exports